import { constants } from '../../common/common.js';

export const appdownloadButton = function (page) {//eslint-disable-line
    const appStoreElement = document.querySelector('.sparks-app-download__mob-appstore');
    const googlePlayElement = document.querySelector('.sparks-app-download__mob-google-play');
    const appStoreLgElement = document.querySelector('button.sparks-app-download__appstore-button');
    const googlePlayLgElement = document.querySelector('button.sparks-app-download__google-play-button');

    if (appStoreElement) {
        appStoreElement.addEventListener('click', () => {
            if (typeof utag !== 'undefined') {//eslint-disable-line
                utag.link({ link_name: `sparks:${page}:app download:click:apple` });//eslint-disable-line
            }
            window.location.replace(constants.appDownloadElement);
        });
    }
    if (googlePlayElement) {
        googlePlayElement.addEventListener('click', () => {
            if (typeof utag !== 'undefined') {//eslint-disable-line
                utag.link({ link_name: `sparks:${page}:app download:click:google` });//eslint-disable-line
            }
            window.location.replace(constants.appDownloadElement);
        });
    }
    if (appStoreLgElement) {
        appStoreLgElement.addEventListener('click', () => {
            if (typeof utag !== 'undefined') {//eslint-disable-line
                utag.link({ link_name: `sparks:${page}:qr-bnr:app download:click:apple` });//eslint-disable-line
            }
            window.location.replace(constants.appDownloadElement);
        });
    }
    if (googlePlayLgElement) {
        googlePlayLgElement.addEventListener('click', () => {
            if (typeof utag !== 'undefined') {//eslint-disable-line
                utag.link({ link_name: `sparks:${page}:qr-bnr:app download:click:google` });//eslint-disable-line
            }
            window.location.replace(constants.appDownloadElement);
        });
    }
};

export const sparksthumbnails = function () {//eslint-disable-line
    const thumbnailCard = document.querySelectorAll('.sparks-thumbnails__subcard');
    if (thumbnailCard) {
        for (let a = 0; a < thumbnailCard.length; a++) {
            thumbnailCard[a].addEventListener('click', (e) => {
                const targetValue = e.target.parentElement.getAttribute('data-target') ? e.target.parentElement.getAttribute('data-target') : e.target.getAttribute('data-target');
                if (targetValue) {
                    location.replace(`${targetValue}`);
                }
            });
        }
    }
};

export const setAnalyticsBenefitThumbnailsPresent = function (page) {//eslint-disable-line
    /* eslint-disable camelcase, no-undef */
    var utag_data = window.utag_data || {};
    utag_data.component_name = utag_data.component_name || [];
    utag_data.component_name.push(`sparks_${page}_thumb-card_your-sparks`);
    utag_data.component_event = ['component_present'];
    try {
        utag.view(utag_data);
    } catch (e) {
        console.log('Error in executing utag. Ignore this if it is local environment'); // eslint-disable-line no-console
    }
};

export const isBenefitsThumbnailsPresent = function () {//eslint-disable-line
    const thumbnailsCards = document.querySelectorAll('.sparks-thumbnails__card .sparks-thumbnails__subcard');
    if (thumbnailsCards) {
        return thumbnailsCards.length > 0;
    }
    return false;
};

export const setAnalyticsBenefitThumbnailsScrolledIntoview = function (page) {//eslint-disable-line
    /* eslint-disable camelcase, no-undef */
    var utag_data = window.utag_data || {};
    utag_data.link_name = `sparks:${page}:component seen`;
    utag_data.component_name = utag_data.component_name || [];
    utag_data.component_name.push(`sparks_${page}_thumb-card_your-sparks`);
    utag_data.component_event = ['component_seen'];
    try {
        utag.link(utag_data);
    } catch (e) {
        console.log('Error in executing utag. Ignore this if it is local environment'); // eslint-disable-line no-console
    }
};

export const setAnalyticsBenefitThumbnailsScrollListener = function (page) {//eslint-disable-line
    const thumbnailsCard = document.querySelector('.sparks-thumbnails__card .sparks-thumbnails__subcard');
    let alreadySeen = false;
    window.addEventListener('scroll', () => {
        if (isScrolledIntoView(thumbnailsCard) && !alreadySeen) {
            alreadySeen = true;
            setAnalyticsBenefitThumbnailsScrolledIntoview(page);
        }
    });
};

function isScrolledIntoView(el) {
    const rect = el.getBoundingClientRect();
    const elemTop = rect.top;
    const elemBottom = rect.bottom;
    if (!elemTop && !elemBottom) {
        return false;
    }
    // Only completely visible elements return true:
    const isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);//eslint-disable-line
    return isVisible;
}